import { render } from "./claims.vue?vue&type=template&id=b3e81a84&scoped=true"
import script from "./claims.vue?vue&type=script&lang=js"
export * from "./claims.vue?vue&type=script&lang=js"

import "./claims.vue?vue&type=style&index=0&id=b3e81a84&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3e81a84"]])

export default __exports__